import { useEffect } from 'react'

import { SubmitHandler, UseFormProps, UseFormReturn } from 'react-hook-form'
import { z } from 'zod'

import { useFormWithSchema } from '@fortem-monorepo/react-spa'
import { Form } from '@fortem-monorepo/react-ui'

import { riskSchema as schema } from '@/components/forms/pricing-interface/schemas'
import { useRunRiskMutation } from '@/react-query/mutations/pricing-interface'

export type SchemaType = z.infer<typeof schema>

export interface RunRiskFormProps extends Omit<UseFormProps<SchemaType>, 'resolver'> {
  children?: ((form: UseFormReturn<SchemaType>) => React.ReactNode) | React.ReactNode
  onSubmit?: SubmitHandler<SchemaType>
}

export const RunRiskForm: React.FC<RunRiskFormProps> = ({ children, onSubmit, ...props }) => {
  const form = useFormWithSchema({ mode: 'all', ...props }, schema)

  const runRiskMutation = useRunRiskMutation()

  const submit = form.handleSubmit(
    onSubmit ??
      (async (_data, _e) => {
        await runRiskMutation.mutateAsync(_data)
        form.reset()
      }),
  )

  useEffect(() => {
    form.trigger()
  }, [])

  return (
    <Form {...form}>
      <form onSubmit={submit}>{typeof children === 'function' ? children(form) : children}</form>
    </Form>
  )
}
